import { memo } from "react";
import { Box } from "@mui/material";

function RightTickIcon({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="28"
        height="20"
        viewBox="0 0 28 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.5627 0.437451C28.1502 1.02495 28.1502 1.97495 27.5627 2.5562L11.0627 19.0625C10.4752 19.65 9.5252 19.65 8.94395 19.0625L0.437695 10.5625C-0.149805 9.97495 -0.149805 9.02495 0.437695 8.4437C1.0252 7.86245 1.9752 7.8562 2.55645 8.4437L9.99395 15.8812L25.4377 0.437451C26.0252 -0.150049 26.9752 -0.150049 27.5564 0.437451H27.5627Z"
          fill="#6BB700"
        />
      </svg>
    </Box>
  );
}

export default memo(RightTickIcon);
